<template>
    <div :role="ariaRole"
         :class="`choice --dynamic ${activeStateModifier}${disabled ? ' --disabled' : ''}`"
         tabindex="0"
         @click="onWrapperClickOrEnter"
         @keyup.enter="onWrapperClickOrEnter">
        <input v-if="active"
               ref="input"
               type="text"
               class="choice__input"
               :placeholder="text"
               v-model="inputValue">
        <button v-else
                :id="`choice-${value}`"
                :class="`choice__button --${value}`"
                :disabled="disabled"
                tabindex="-1"
                @click="$emit('click', value)"
                @keyup.enter="$emit('click', value)">
            <span class="choice__button__text">{{ text }}</span>
        </button>
    </div>
</template>

<script>

import MathTools from '@/helpers/math-tools'

import { baseChoice } from './choice'

export default {

    mixins: [
        baseChoice,
    ],

    props: {
        text: {
            type: [ String, Number ],
            default: '(enter value)',
        },
    },

    computed: {

        ariaRole() {
            return !this.active ? 'button' : 'none'
        },

        inputValue: {
            get() {
                return this.value > 0 ? MathTools.segmentCurrency(this.value, '£') : ''
            },
            set(value) {
                this.$emit('input', parseInt(this._cleanValue(value)))
            },
        },

        valueDisplay() {
            return MathTools.segmentCurrency(this.innerValue, this.currency)
        },
    },

    updated() {
        if (this.active) this.$refs.input.focus()
    },

    methods: {

        _cleanValue(value) {
            return String(value).replace(/[^\d.-]/g, '')
        },

        onWrapperClickOrEnter() {
            if (this.active)
                this.$refs.input.focus()
            else
                this.$emit('click', this.value)
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\plan-chooser\_choice.scss

.choice {

    &.--dynamic {

        > input {
            background: transparent;
            border: none;
            margin: 0;
            width: 100%;
            text-align: center;
            padding: 0.7rem;

            @include bp-min-mid {
                padding: 1rem 1.5rem;
            }

            @include bp-min-wide {
                padding: 1.5rem;
            }
        }

        @include bp-min-wide {
            width: 20%;
        }
    }
}

</style>
